import { useState } from 'react';

import { Form, Field } from 'react-final-form';

import { required } from 'helpers/InputValidators';
import { handleErrorMessage } from 'helpers/forms';

import { BaseModal } from 'components/Toolkit/Modal/BaseModal';
import { Button } from 'components/Toolkit/Button/Button';
import { MiniUserProfile } from 'components/Toolkit/MiniUserProfile/MiniUserProfile';
import { Loading } from 'components/Toolkit/Loading/Loading';

import * as Styled from 'components/PageWrappers/AdDetails/components/SendMessageModal/SendMessageModal.styled';
import type { SendMessageModalProps } from 'components/PageWrappers/AdDetails/components/SendMessageModal/SendMessageModal.typed';
import { useSendMessageModal } from 'components/PageWrappers/AdDetails/components/SendMessageModal/SendMessageModal.hook';

import { CDN_STATIC_ASSETS } from '../../../../../utils';

function SendMessageModal(props: SendMessageModalProps) {
  const {
    isOpen,
    askToClose,
    title,
    county,
    type,
    isTrader,
    illustration,
    verification,
    message = '',
    sendButtonTrackingId,
    contentCSS,
    adId,
    authorizationHeader,
    setIsPostEnquirySimilarAdsModalOpen,
    sectionName,
    setSimilarAds,
  } = props;

  const [isSubmitting, setIsSubmitting] = useState(false);

  const { onSubmit } = useSendMessageModal({
    adId,
    authorizationHeader,
    askToClose,
    setIsPostEnquirySimilarAdsModalOpen,
    sectionName,
    setSimilarAds,
    setIsSubmitting,
  });

  return (
    <BaseModal
      isOpen={isOpen}
      askToClose={askToClose}
      testId="send-message-modal"
      contentCSS={contentCSS}
    >
      <MiniUserProfile
        title={title}
        illustration={illustration}
        county={county}
        type={type}
        isTrader={isTrader}
        verification={verification}
      />
      <Styled.SVerifiedList verification={verification} />
      <Form
        onSubmit={onSubmit}
        initialValues={{ message }}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} noValidate>
            <Field<string>
              name="message"
              validate={required('Message Required')}
            >
              {({ input, meta }) => (
                <Styled.STextArea
                  name={input.name}
                  value={input.value}
                  onChange={input.onChange}
                  errorMessage={handleErrorMessage(meta)}
                />
              )}
            </Field>
            <Button
              type="submit"
              data-testid="send-message"
              data-tracking={sendButtonTrackingId}
            >
              {isSubmitting ? (
                <Loading color="LIGHT" cdnUrl={CDN_STATIC_ASSETS} />
              ) : (
                'Send'
              )}
            </Button>
          </form>
        )}
      />
    </BaseModal>
  );
}

export { SendMessageModal };
